function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M28.9849 23.3117V8.99308C28.9849 6.35796 31.1207 4.22397 33.7559 4.22397L37.9825 4.2296C40.6102 4.23523 42.7366 6.36547 42.7366 8.99308V12.0411C42.7366 14.6762 40.6008 16.8121 37.9675 16.8121H31.9935M43.9172 4.22021H45.7509C46.832 4.22021 47.7085 5.09671 47.7085 6.17778V16.874",
  stroke: "#003854",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M47.3161 2.56473L46.4847 1.73328C46.2782 1.52683 46.2782 1.19275 46.4847 0.986292L47.3161 0.154841C47.5226 -0.0516138 47.8585 -0.0516138 48.065 0.154841L48.8964 0.986292C49.1029 1.19275 49.1029 1.52683 48.8964 1.73328L48.065 2.56473C47.8585 2.77119 47.5245 2.77119 47.318 2.56473H47.3161Z",
  fill: "#003854"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M51.2275 4.21094H53.0462C53.9809 4.21094 54.8799 4.58256 55.5406 5.24321L59.7935 9.49619C60.3453 10.048 61.2387 10.048 61.7886 9.49619L66.0266 5.25823C66.6873 4.59757 67.5844 4.22595 68.521 4.22595H69.9999M51.2275 16.7803H53.0462C53.9809 16.7803 54.8799 16.4087 55.5406 15.748L59.7935 11.495C60.3453 10.9432 61.2387 10.9432 61.7886 11.495L66.0266 15.733C66.6873 16.3937 67.5844 16.7653 68.521 16.7653H69.9999",
  stroke: "#003854",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M18.1423 17.8089C17.2302 17.8089 16.3706 17.4542 15.7249 16.8085L12.2358 13.3194C11.9919 13.0736 11.5639 13.0754 11.3199 13.3194L7.81771 16.8217C7.17207 17.4673 6.31434 17.822 5.40031 17.822H4.71338L9.13339 22.2421C10.5129 23.6215 12.752 23.6215 14.1315 22.2421L18.5628 17.8108H18.1423V17.8089Z",
  fill: "#003854"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M5.4021 5.46594C6.31425 5.46594 7.17386 5.82067 7.8195 6.46631L11.3217 9.96854C11.5732 10.22 11.9861 10.2219 12.2395 9.96854L15.7286 6.47945C16.3742 5.83381 17.232 5.47908 18.146 5.47908H18.5664L14.1351 1.0478C12.7556 -0.33169 10.5166 -0.33169 9.13706 1.0478L4.71704 5.46782H5.40397L5.4021 5.46594Z",
  fill: "#003854"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M22.23 9.14511L19.5518 6.46683C19.4936 6.49123 19.4298 6.50436 19.3622 6.50436H18.1441C17.5154 6.50436 16.8979 6.75962 16.4531 7.20443L12.964 10.6935C12.6374 11.0201 12.2095 11.1834 11.7797 11.1834C11.3499 11.1834 10.9219 11.0201 10.5954 10.6935L7.09314 7.1913C6.64832 6.74648 6.03271 6.49123 5.40208 6.49123H3.90435C3.84053 6.49123 3.78047 6.47621 3.72417 6.45557L1.03462 9.14511C-0.344874 10.5246 -0.344874 12.7637 1.03462 14.1432L3.72417 16.8327C3.78047 16.8121 3.84053 16.7971 3.90435 16.7971H5.40208C6.03083 16.7971 6.64832 16.5418 7.09314 16.097L10.5954 12.5948C11.2279 11.9623 12.3315 11.9623 12.964 12.5948L16.4531 16.0839C16.8979 16.5287 17.5135 16.7839 18.1441 16.7839H19.3622C19.4298 16.7839 19.4936 16.799 19.5518 16.8215L22.23 14.1432C23.6095 12.7637 23.6095 10.5246 22.23 9.14511Z",
  fill: "#003854"
});

var SvgPixMeireles = function SvgPixMeireles(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 24,
    viewBox: "0 0 71 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPixMeireles, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pix_meireles.d697bedc.svg";
export { ForwardRef as ReactComponent };